export default "__VITE_ASSET__BINEm74u__"